export const REQUEST_FEATURE = "Profile/REQUEST_FEATURE";
export const REQUEST_FEATURE_SUCCESSFULL = "Profile/REQUEST_FEATURE_SUCCESSFULL";
export const REQUEST_FEATURE_FAILED = "Profile/REQUEST_FEATURE_FAILED";
export const RESET_REQUEST_FEATURE_STORE = "Profile/RESET_REQUEST_FEATURE_STORE";
